import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useMutation } from '@tanstack/react-query'
import { HealthClaimFormInput } from '../types'

const updateHealthClaim = async (data: HealthClaimFormInput) => {
  const response = await httpClientPrivate.post(
    `${config.restUrl}/v1/backoffice/e-claim/${data.claimFormId}/edit`,
    data,
  )

  return response.data
}

const useUpdateHealthClaim = () => {
  const mutation = useMutation({
    mutationKey: ['useUpdateHealthClaim'],
    mutationFn: async (data: HealthClaimFormInput) => updateHealthClaim(data),
  })

  return mutation
}

export { useUpdateHealthClaim }
